import { Image } from "@react-pdf/renderer";

const renderLogo = ({ logoName }) => (
    <Image
        src={`/img/${logoName}`}
        style={{ width: '80%', height: 100 }}
    />
);

const renderLogoFunds = ({ logoName }) => (
    <Image
        src={`/img/${logoName}`}
        style={{ width: '100%', height: 100 }}
    />
);

const image = {
    renderLogo,
    renderLogoFunds
}

export default image;